module.exports = __webpack_public_path__ + "static/media/edit-profile.8b45a874.svg";